import { IconButton } from '@lemonade-hq/uniclient-theme';
import type { IconButtonProps } from '@lemonade-hq/uniclient-theme';
import React from 'react';

export interface FreeTextInputButtonProps {
  readonly showFreeTextInput?: boolean;
  readonly setShowFreeTextInput?: (showFreeTextInput: boolean) => void;
  readonly size?: IconButtonProps['size'];
}

export const FreeTextInputButton: React.FC<FreeTextInputButtonProps> = ({
  showFreeTextInput,
  setShowFreeTextInput,
  size = 'md',
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setShowFreeTextInput?.(!showFreeTextInput);
  };

  const handleMouseDown = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
  };

  return (
    <IconButton background="transparent" icon="stars" onClick={handleClick} onMouseDown={handleMouseDown} size={size} />
  );
};
